import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Fragment } from '@wordpress/element';
import { __, _n, sprintf } from '@wordpress/i18n';

function DownloadableBlockAuthorInfo(_ref) {
  var author = _ref.author,
      authorBlockCount = _ref.authorBlockCount,
      authorBlockRating = _ref.authorBlockRating;
  return createElement(Fragment, null, createElement("span", {
    className: "block-directory-downloadable-block-author-info__content-author"
  }, sprintf(__('Authored by %s'), author)), createElement("span", {
    className: "block-directory-downloadable-block-author-info__content"
  }, sprintf(_n('This author has %d block, with an average rating of %d.', 'This author has %d blocks, with an average rating of %d.', authorBlockCount), authorBlockCount, authorBlockRating)));
}

export default DownloadableBlockAuthorInfo;
//# sourceMappingURL=index.js.map